import { Toast } from '@services/components/ToastService/toast.types';

const BASE_SUCCESS_TOAST: Omit<Toast, 'title' | 'description'> = {
  id: '',
  open: true,
  type: 'success',
  variant: 'outline',
  showIcon: true,
  dismissible: true,
};

export const buildSuccessColorToast = (editing: boolean): Toast => ({
  ...BASE_SUCCESS_TOAST,
  title: editing ? 'Color actualizado' : 'Color creado',
  description: editing
    ? 'Los cambios han sido guardados exitosamente.'
    : 'El color ha sido creado exitosamente.',
});

export const buildSuccessShippingBoxToast = (editing: boolean): Toast => ({
  ...BASE_SUCCESS_TOAST,
  title: editing ? 'Caja actualizada' : 'Caja creada',
  description: editing
    ? 'Los cambios han sido guardados exitosamente.'
    : 'La caja ya se usa para cotizar los despachos.',
});

export const buildSuccessProductToast = (editing: boolean): Toast => ({
  ...BASE_SUCCESS_TOAST,
  title: editing ? 'Producto actualizado' : 'Producto creado',
  description: editing
    ? 'Los cambios han sido guardados exitosamente.'
    : 'El producto ha sido creado exitosamente.',
});

export const SUCCESS_DELETE_COLOR_TOAST: Toast = {
  ...BASE_SUCCESS_TOAST,
  title: 'Color eliminado',
  description: 'El color ha sido eliminado correctamente.',
};

export const SUCCESS_DELETE_PRODUCT_TOAST: Toast = {
  ...BASE_SUCCESS_TOAST,
  title: 'Producto eliminado',
  description: 'El producto ha sido eliminado correctamente.',
};

export const buildOrderStatusToast = (statusLabel: string): Toast => ({
  ...BASE_SUCCESS_TOAST,
  title: 'Estado actualizado',
  description: `El pedido pasó a "${statusLabel}".`,
});

export const ORDER_NUMBER_COPIED_TOAST: Toast = {
  ...BASE_SUCCESS_TOAST,
  title: 'ID copiado',
  description: 'El ID del pedido se copió al portapapeles.',
};

export const ERROR_ORDER_STATUS_TOAST: Toast = {
  id: '',
  open: true,
  type: 'error',
  variant: 'outline',
  showIcon: true,
  dismissible: true,
  title: 'No se pudo actualizar',
  description: 'El estado del pedido se restauró. Intenta de nuevo.',
};

export const buildOrderStatusErrorToast = (message?: string): Toast => ({
  ...ERROR_ORDER_STATUS_TOAST,
  description: message ?? ERROR_ORDER_STATUS_TOAST.description,
});

export const AUDIT_LOG_COPIED_TOAST: Toast = {
  ...BASE_SUCCESS_TOAST,
  title: 'Registro copiado',
  description: 'Pégalo en un correo o WhatsApp para enviarlo al desarrollador.',
};

export const AUDIT_LOG_COPY_ERROR_TOAST: Toast = {
  id: '',
  open: true,
  type: 'error',
  variant: 'outline',
  showIcon: true,
  dismissible: true,
  title: 'No se pudo copiar',
  description: 'Tu navegador no permitió copiar al portapapeles.',
};
